import { UserModelAPI } from "../../../../models/users/UserModel";
import { getUsersListAdapter } from "../../Adapters/users/Users.adapter";
import { requests } from "../apiAgent";

export const UserAPI = {
    getUsers: () => {
        return requests
            .get('/jerusalem/api/v1/users')
            .then((response: UserModelAPI[]) =>{
                 return getUsersListAdapter(response)
            }               
            );
    },
};